import React, { FC } from "react";
import { QrMaskProps } from "../interfaces";
import { QrTypes } from "../enums";
import { FullScreenMask } from "./components/fullScreenMask/FullScreenMask";
import useStyles from "./styles";

export const QrMask: FC<QrMaskProps> = ({ type, shouldUpdateStyles }) => {
  const classes = useStyles({ shouldUpdateStyles });

  const getFullscreenClassNameByType = () => {
    if (type === QrTypes.ERROR || type === QrTypes.SUCCESS) {
      return classes.readerMaskLeftRightFullscreen;
    }
    return "";
  };

  return (
    <div className={classes.container}>
      <div className={classes.readerMaskTopBottom} />
      <div data-testid="qr-mask-fullscreen" className={`${classes.readerMaskLeftRight} ${getFullscreenClassNameByType()}`} />
      <FullScreenMask type={type} shouldUpdateStyles={shouldUpdateStyles} />
    </div>
  );
};
